<template>
  <div class="twui-footer" id="footer">
    <slot>Copyright © 2008-2022 天闻数媒科技（北京）有限公司, All Rights Reserved</slot>
    <a style="margin-left:15px;" href="/static/dev/images/business_licence.png" target="_blank">经营证照</a>
  </div>
</template>

<script>
export default {
  name: 'TwFooter'
}
</script>



// WEBPACK FOOTER //
// tw-footer.vue?009fa36a